<div class="vi-body w-full min-w-full h-full min-h-full flex-[1_0_auto]">
  <ng-content select="[body]"></ng-content>
</div>
